import React from 'react'
import { Container, Image, Row, Col } from 'react-bootstrap'

const ThankYou = () => {
    return (
        <>
            <Container>
                <Row className='text-center mt-5'>
                    <Col sm={3}></Col>
                    <Col sm={6}>
                        <h1 className='mt-5 main-color' >Thank you for your contribution!</h1>
                        <p  style={{ fontSize: "20px" }}>This action of yours will directly impact the lives of those belonging to the marginalized communities.</p>
                        {/* <Image src={require('../../assets/images/cheked.png')} alt="" className='img-fluid rounded-2 pb-2' style={{ width: "40%" }} /> */}
                        <Image src={require('../../assets/images/Muskaan-logo.png')} alt="" className='img-fluid rounded-2 pb-2' style={{ width: "15%" }} />
                        <p className='main-color' style={{ fontSize: "20px" }}>You will receive the acknowledgment for this contribution in your inbox soon. </p>
                        <p>Please write to us at <a href="mailto:contact@muskaan.org"> contact@muskaan.org </a> for any further assistance. </p>
                    </Col>
                    <Col sm={3}></Col>
                </Row>
            </Container>
        </>
    )
}
export default ThankYou
